export default __webpack_public_path__ + "static/media/gs.62046d1a.svg";